import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core";
import iphone from "../assets/images/iphone.png";

const PR_COLOR = 'rgb(116,118,129)';
const useStyles = makeStyles(() => ({
  title: {
    color: "rgb 0 0 102",
    fontSize: "20px",
    paddingBottom: "20px",
    paddingTop: "30px",
    paddingLeft: "10px"
  },
  publish: {
    fontSize: "14px",
    lineHeight: "20px",
    paddingBottom: "30px",
  },
  box: {
    border: "2px solid gray",
    fontSize: "12px",
    padding: "1px 10px 1px 10px",
    borderRadius: "20%"
  },
  readTime:{
    // fontSize:'13pt',
    color:PR_COLOR
  },
  mobileTxt: {
    position: "absolute",
    top: "17%",
    left:'50%',
    width:'100%',
    height:'470px',
    padding:'30px',
    paddingTop:0,
    transform:'translate(-50%,-10%)',
    overflowX:'hidden',
    "&::-webkit-scrollbar":{
      width:'12px'
    }
  },
  text3: {
    fontSize: "10px !important",
    padding: 28,
    textAlign: "justify"
  },
  giri:{
    padding:0,
    overflow:'hidden',
    maxHeight:'100%'
  },
  gir2:{
    overflow:'hidden',
    padding: "0 !important",
    background:'transparent'
  },
  firstMessage:{
    color:PR_COLOR,
    fontStyle:'italic'
  },
  secondMessage:{
    color:'rgb(0,0,102)',
    fontStyle:'italic'
  },
  thirsMessage:{
    color:PR_COLOR,
    textAlign:'center',
    marginTop:'10px'
  }
}));

export default function DraggableDialog(props) {
  const [content, setContent] = React.useState({});
  const [title, setTitle] = React.useState();

  useEffect(() => {
    if (props.edit) {
      setContent(props.list);
      setTitle(props);
    }
    if (props.list["content"]) {
      setContent(props.list["content"]);
      setTitle(props.list);
    }
  }, []);
  function isValidDate(d) {
    return (new Date(d)).getTime() > 0;
  }

  const customDateFormat = (date) => {
    if (isValidDate(date)) {
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let dateObj = new Date(date);
      let month = monthNames[dateObj.getMonth()];
      let year = dateObj.getFullYear();
      return `${month}, ${year}`;
    } else {
      return `NA`;
    }
  };
  const classes = useStyles();
  return (
    <div>
      <Dialog classes={{paperScrollPaper:"paperScrollPaper"}} open={props.open} onClose={props.handleClose} maxWidth={"xs"}>
        <DialogContent className={classes.gir2} style={{ overflowX: 'hidden' }}>
          <div className={classes.mobile}>
            <img src={iphone} width="100%" />
            <div className={classes.mobileTxt}>
            {content ? (
            <>
              {(props.videoform === "video"|| props.data) ? Array.isArray(content.videoUrl)?
              <>
              <video style={{ width: "100%", height: "200px", marginBottom:'12px' }} controls>
              <source src={content.videoUrl[1]} type="video/ogg" />
              <source src={content.videoUrl[1]} type="video/mp4" />
              <source src={content.videoUrl[1]} type="video/webm" />
              </video>
              </>: <>
              <video style={{ width: "100%", height: "200px", marginBottom:'12px' }} controls>
              <source src={content.videoUrl} type="video/ogg" />
              <source src={content.videoUrl} type="video/mp4" />
              <source src={content.videoUrl} type="video/webm" />
              </video>
              </>:
                <> {content.articleImage?content.articleImage.base64Rep?
                <img src={content.articleImage.base64Rep} style={{ borderRadius: "5%", width: "100%" }} />:
                <img src={content.articleImage} style={{ borderRadius: "5%", width: "100%" }} />:""}
                  </>}
            </>
          ) : (
              ""
            )}
          <div>
            {(content)? (
              <>
                <div className={classes.readTime}>
                  <p>{content["readTime"]}</p>
                </div>
                <hr style={{margin:'12px 0', marginRight: "-23px", marginLeft: "-12px"}}/>
                <div className={classes.publish}>
                  {title && <><h2>{title.title}</h2><br/></>}
                  <strong >
                    {"Author: " + content["author"]}
                  </strong>
                  <p >
                    {"Published by " + content["publication"] + " | " + customDateFormat(content["publishedDate"])}
                  </p>
                </div>
              </>
            ) : (
                ""
              )}
            <hr/>
            <div style={{ marginTop: "20px" }}>
              {content ? <>
                <div dangerouslySetInnerHTML={{ __html:content["contentBody"]}} style={{ paddingTop: "15px", paddingBottom: "10px",paddingLeft: "6px", }} />
                </> : ""}
            </div>
            {(content.disclaimerOne !== null && content.disclaimerOne !== undefined && content.disclaimerOne !== 'N/A' && content.disclaimerOne !== "") &&
              <>
                <hr style={{ margin: '12px 0', marginRight: "-23px", marginLeft: "-12px" }} />
                <div className={classes.firstMessage}>
                  <p>{content.disclaimerOne}</p>
                </div>
              </>
            }
            {(content.disclaimerTwo !== null && content.disclaimerTwo !== undefined && content.disclaimerTwo !== 'N/A' && content.disclaimerTwo !== "") &&
              <>
                <hr style={{ margin: '12px 0', marginRight: "-23px", marginLeft: "-12px" }} />
                <div className={classes.firstMessage}>
                  <p>{content.disclaimerTwo}</p>
                </div>
              </>
            }

            <hr style={{margin:'12px 0', marginRight: "-23px", marginLeft: "-12px"}}/>
            <div className={classes.secondMessage}>
            <p>MyHOPE™ for MM is part of a research study and does not provide medical advice. Only your care team can determine the right treatment for you.</p>
            </div>
            <div className={classes.thirsMessage}>
              <p>For Investigational Use Only</p>
            </div>

          </div>
            </div>
          </div>

        </DialogContent>
      </Dialog>
    </div>
  );
}
